import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconWallet5"><Path d="M19.25 4C20.7688 4 22 5.23122 22 6.75V8.5H17.25C15.7312 8.5 14.5 9.73122 14.5 11.25V12.75C14.5 14.2688 15.7312 15.5 17.25 15.5H22V17.25C22 18.7688 20.7688 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25V6.75C2 5.23122 3.23122 4 4.75 4H19.25Z" fill="currentColor"/><Path d="M16 11.25C16 10.5596 16.5596 10 17.25 10H21.75C22.4404 10 23 10.5596 23 11.25V12.75C23 13.4404 22.4404 14 21.75 14H17.25C16.5596 14 16 13.4404 16 12.75V11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWallet5;
